/**
 * Path data of the Apple and Google logos, the single copy in the codebase.
 *
 * Two surfaces draw these glyphs: the social sign-in buttons
 * (containers/AuthenticationPage/SocialLoginButtons/socialLoginLogos.js) and the wallet marks in the
 * order panel's payment row (components/OrderPanel/PaymentMethodIcons). Each used to carry its own
 * copy of the same trademark artwork, which drifts the moment one of them is corrected — and ships
 * the same bytes twice. The brands' colours are part of the artwork and must not change.
 */

/** Apple logo; draws into x 7.45..17.36, y 2.40..14.37 (see socialLoginLogos for the framing). */
export const APPLE_LOGO_PATH =
  'M15.462 10.544c-.022-2.234 1.823-3.306 1.906-3.358-.037-.055-1.039-1.587-2.645-1.91-.694-.131-1.434-.131-2.072.19-.366.184-.687.444-1.066.444-.387 0-.769-.267-1.264-.257-.978.01-1.88.568-2.384 1.443-1.018 1.764-.26 4.379.731 5.813.485.702 1.064 1.49 1.824 1.462.731-.029 1.008-.474 1.892-.474.878 0 1.135.474 1.904.459.787-.013 1.285-.715 1.766-1.42.366-.518.638-1.087.804-1.69-1.254-.54-1.397-2.155-.396-2.702zM13.162 4.104c.36-.46.61-1.072.543-1.704-.527.027-1.166.372-1.54.816-.34.396-.638 1.03-.558 1.634.585.045 1.183-.313 1.555-.746z';

/** Google "G", four coloured segments in a 20x20 box. */
export const GOOGLE_LOGO_PATHS = [
  {
    d:
      'M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z',
    fill: '#4285F4',
  },
  {
    d:
      'M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z',
    fill: '#34A853',
  },
  {
    d:
      'M4.405 11.9c-.2-.6-.314-1.24-.314-1.9 0-.66.114-1.3.314-1.9V5.51H1.064A9.996 9.996 0 000 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z',
    fill: '#FBBC05',
  },
  {
    d:
      'M10 3.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.192 5.736 7.396 3.977 10 3.977z',
    fill: '#EA4335',
  },
];
